import {Base,Axios} from "@/api/Base"

export class SalaryExport extends Base {
    path = "salary/export"
    download(param = {}) {
      return Axios.get(this.path,{ params: param, responseType: "blob" })
  }
}